import React, { useMemo } from 'react';
import { ArrowRight, HardDrive } from 'lucide-react';
import { useNas } from './NasProvider';

const normalize = (value = '') => String(value).toLocaleLowerCase('vi-VN').normalize('NFD').replace(/\p{M}/gu, '').replace(/đ/g, 'd').trim();

// Header quick search: list archived books that match the query.
export default function NasQuickResults({ query, onOpen }) {
    const nas = useNas();
    const needle = normalize(query);
    const matches = useMemo(() => {
        if (!nas || needle.length < 2) return [];
        return nas.items
            .filter(item => !item.quarantined && normalize(`${item.work} ${item.author} ${(item.keys || []).join(' ')}`).includes(needle))
            .slice(0, 4);
    }, [nas, needle]);

    if (!matches.length) return null;
    return (
        <>
            <div className="quick-search-section">Có trên Kho NAS</div>
            {matches.map(item => (
                <button key={item.id} type="button" onMouseDown={event => event.preventDefault()} onClick={() => onOpen(item)} className="quick-search-result">
                    <span className="quick-search-icon"><HardDrive size={16} /></span>
                    <span className="min-w-0"><strong>{item.work}</strong><small>{item.author} · {item.genre}</small></span>
                    <ArrowRight size={14} className="ml-auto shrink-0" />
                </button>
            ))}
        </>
    );
}
